import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const createTaxSlice = createAsyncThunk(
  "tax/createTax",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/tax/createTax",
        data,
        {
          headers: {
            "Content-": "application/json",
            token: data.token,
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getTaxSlice = createAsyncThunk(
  "tax/getAllTax",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/tax/getAllTax", data, {
        headers: {
          "Content-": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getTaxByIdSlice = createAsyncThunk(
  "tax/getTaxById",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/tax/getTaxById",
        data,
        {
          headers: {
            "Content-": "application/json",
            token: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const updateTaxSlice = createAsyncThunk(
  "tax/updateTax",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put("/tax/updateTax", data, {
        headers: {
          "Content-": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const deleteTaxSlice = createAsyncThunk(
  "tax/deleteTax",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put("/tax/deleteTax", data, {
        headers: {
          "Content-": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

const initialState = {
  loading: false,
  tax: [],
  taxInfo: [],
  createTaxSuccessMessage: null,
  createTaxErrorMessage: null,
  updateTaxSuccessMessage: null,
  updateTaxErrorMessage: null,
  deleteTaxSuccessMessage: null,
  deleteTaxErrorMessage: null,
  searchTaxErrorMessage: null,
};

const taxSlice = createSlice({
  name: "Tax",
  initialState,
  reducers: {
    resetCreateTaxMessage: (state) => {
      state.createTaxSuccessMessage = null;
      state.createTaxErrorMessage = null;
    },
    resetUpdateTaxMessage: (state) => {
      state.updateTaxSuccessMessage = null;
      state.updateTaxErrorMessage = null;
    },
    resetDeleteTaxMessage: (state) => {
      state.deleteTaxSuccessMessage = null;
      state.deleteTaxErrorMessage = null;
    },
    resetSearchTaxMessage: (state) => {
      state.searchTaxErrorMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createTaxSlice.pending, (state) => {
        state.loading = true;
        state.createTaxSuccessMessage = null;
        state.createTaxErrorMessage = null;
      })
      .addCase(createTaxSlice.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.createTaxErrorMessage = action?.payload?.result?.message;
        } else {
          state.createTaxSuccessMessage = action?.payload?.result?.message;
        }
      })
      .addCase(createTaxSlice.rejected, (state, action) => {
        state.loading = false;
        state.createTaxErrorMessage = action?.payload?.result?.message;
      })
      .addCase(getTaxSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTaxSlice.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.searchTaxErrorMessage = action?.payload?.result?.message;
        }
        state.tax = action?.payload?.result?.list;
      })
      .addCase(getTaxSlice.rejected, (state, action) => {
        state.loading = false;
        state.searchTaxErrorMessage = action?.payload?.result?.message;
      })
      .addCase(getTaxByIdSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTaxByIdSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.taxInfo = action?.payload?.result?.list;
      })
      .addCase(getTaxByIdSlice.rejected, (state, action) => {
        state.loading = false;
        state.searchTaxErrorMessage = action?.payload?.result?.message;
      })
      .addCase(updateTaxSlice.pending, (state) => {
        state.loading = true;
        state.updateTaxSuccessMessage = null;
        state.updateTaxErrorMessage = null;
      })
      .addCase(updateTaxSlice.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.updateTaxErrorMessage = action?.payload?.result?.message;
        } else {
          state.updateTaxSuccessMessage = action?.payload?.result?.message;
        }
      })
      .addCase(updateTaxSlice.rejected, (state, action) => {
        state.loading = false;
        state.updateTaxErrorMessage = action?.payload?.result?.message;
      })
      .addCase(deleteTaxSlice.pending, (state) => {
        state.loading = true;
        state.deleteTaxSuccessMessage = null;
        state.deleteTaxErrorMessage = null;
      })
      .addCase(deleteTaxSlice.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.deleteTaxErrorMessage = action?.payload?.result?.message;
        } else {
          state.deleteTaxSuccessMessage = action?.payload?.result?.message;
        }
      })
      .addCase(deleteTaxSlice.rejected, (state, action) => {
        state.loading = false;
        state.deleteTaxErrorMessage = action?.payload?.result?.message;
      });
  },
});

export const {
  resetCreateTaxMessage,
  resetUpdateTaxMessage,
  resetDeleteTaxMessage,
  resetSearchTaxMessage,
} = taxSlice.actions;

export default taxSlice.reducer;